import jsQR from 'jsqr';

const MAX_FILE_BYTES = 15 * 1024 * 1024;
// Phone screenshots are large; try full size first, then smaller copies, which
// helps blurry or very high resolution images.
const MAX_SIDES = [1600, 1000, 640];

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('อ่านไฟล์รูปไม่ได้'));
    };
    image.src = url;
  });
}

function scan(image, maxSide) {
  const scale = Math.min(1, maxSide / Math.max(image.naturalWidth, image.naturalHeight));
  const width = Math.max(1, Math.round(image.naturalWidth * scale));
  const height = Math.max(1, Math.round(image.naturalHeight * scale));
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext('2d', { willReadFrequently: true });
  context.fillStyle = '#fff';
  context.fillRect(0, 0, width, height);
  context.drawImage(image, 0, 0, width, height);
  const { data } = context.getImageData(0, 0, width, height);
  const code = jsQR(data, width, height, { inversionAttempts: 'attemptBoth' });
  return code && code.data ? code.data : null;
}

// Reads the QR text from an image file entirely in the browser (the picture is
// never uploaded). Returns the decoded string, or null when no QR is found.
export async function decodeQrFromFile(file) {
  if (!file || !String(file.type).startsWith('image/')) {
    throw new Error('กรุณาเลือกไฟล์รูปภาพ (JPG, PNG)');
  }
  if (file.size > MAX_FILE_BYTES) {
    throw new Error('ไฟล์รูปใหญ่เกินไป (ไม่เกิน 15MB)');
  }
  const image = await loadImage(file);
  for (let i = 0; i < MAX_SIDES.length; i += 1) {
    const text = scan(image, MAX_SIDES[i]);
    if (text) return text;
  }
  return null;
}
